import { CollectionTypes, URI } from '~/types/adamTypes';

export const getUriForCollection = (collection: CollectionTypes) => {
  const values = Object.values(CollectionTypes);
  const keys = Object.keys(CollectionTypes);
  const mc = new Map<string, string>();
  values.forEach((value, index) => mc.set(value, keys[index]));
  return URI[mc.get(collection)];
};
